import { observer } from 'mobx-react-lite';
import Markdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

import { twMerge } from 'tailwind-merge';
import { CommonLink } from '../CommonLink';

export const MarkdownViewer = observer(
    ({
        markdown = '',
        components = {},
        className,
    }: {
        markdown: string;
        /**
         * 컴포넌트 옵션
         * 예: 앵커 태그를 커스터마이징
         */
        components?: Components;
        className?: string;
    }) => {
        const content = markdown?.trim() || '';

        // prose 클래스에 대한 스타일은 tailwind.config.js 에서 설정함
        const defaultComponents: Components = {
            a: ({ href, children }) => <CommonLink to={href || ''}>{children}</CommonLink>,
            img: ({ src, alt }) => <img src={src} alt={alt} loading="lazy" className="w-full" />,
            // 기본 text-sm 로 적용
            p: ({ children }) => <p className="text-sm">{children}</p>,
            li: ({ children }) => <li className="text-sm">{children}</li>,
            ul: ({ children }) => <ul className="text-sm">{children}</ul>,
            ol: ({ children }) => <ol className="text-sm">{children}</ol>,
            blockquote: ({ children }) => <blockquote className="text-sm">{children}</blockquote>,
            code: ({ children }) => <code className="text-sm">{children}</code>,
            pre: ({ children }) => <pre className="text-sm">{children}</pre>,
            table: ({ children }) => <table className="text-sm">{children}</table>,
            th: ({ children }) => <th className="text-sm">{children}</th>,
            td: ({ children }) => <td className="text-sm">{children}</td>,
        };

        const mergedComponents = {
            ...defaultComponents,
            ...components,
        };

        return (
            <div className={twMerge('prose text-base-content/90 max-w-none', className)}>
                <Markdown
                    remarkPlugins={[
                        // github flavored markdown
                        remarkGfm,
                        // 줄바꿈 처리
                        remarkBreaks,
                    ]}
                    components={mergedComponents}
                >
                    {content}
                </Markdown>
            </div>
        );
    },
);
